import { HttpService } from "@core/services/http.service.ts";
import { apiURL } from "@utils/environment.ts";
import { PaginateResponse } from "@utils/appUtils.ts";
import {
  InterimAgentDTO,
  InterimAgentPostDTO,
} from "./interimAgent.model.ts";

export class InterimAgentService extends HttpService {
  private APIURL = apiURL;

  createInterimAgent(data: InterimAgentPostDTO): Promise<InterimAgentDTO> {
    this.urlAPI = `${this.APIURL}/interim-agent`;
    return this.doPost<InterimAgentDTO, InterimAgentPostDTO>(data);
  }

  getAllInterimAgents(
    page: number,
    size: number,
    sortBy?: string,
    sortDir?: string,
    search?: string,
    active?: string
  ): Promise<PaginateResponse<InterimAgentDTO>> {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
      sortBy: sortBy ?? "",
      sortDir: sortDir ?? "",
      search: search ?? "",
    });
    if (active !== undefined && active !== null) {
      params.append("active", active);
    }
    this.urlAPI = `${this.APIURL}/interim-agent?${params}`;
    return this.doGet<PaginateResponse<InterimAgentDTO>>();
  }

  returnInterimAgent(id: number): Promise<any> {
    this.urlAPI = `${this.APIURL}/interim-agent/${id}/return`;
    return this.doPut<any, {}>({}); 
  }
}

export const interimAgentService = new InterimAgentService();
